import React from "react";
export default function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      style={{ width: "100%", height: "100%" }}
      //margin="0 auto"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", padding: 0 }}>
          {children}
        </div>
      )}
    </div>
  );
}
